module.exports = __webpack_public_path__ + "static/media/syringe.97c9c3f5.png";